import classNames from 'classnames';
import React, { HTMLAttributes } from 'react';

import { RichMediaValue } from '@/interface/media';
import { getMediaUrlValue } from '@/material/form-upload/change-data';

import styles from './index.module.less';

export interface CoverProps extends HTMLAttributes<HTMLDivElement> {
  src?: RichMediaValue;
  width?: number;
  height?: number;
  borderRadius?: string;
  outerClassName?: string;
  innerClassName?: string;
  hasInner?: boolean;
}

/**
 * 视频封面样式组件
 */
const Video: React.FC<CoverProps> = ({
  src,
  width = 158,
  height = 90,
  borderRadius = 0,
  hasInner = true,
  className,
  outerClassName,
  innerClassName,
  children,
  onClick,
}) => {
  const url = getMediaUrlValue(src);
  return (
    <div
      className={classNames(styles.cover, className)}
      style={{ width, height, borderRadius }}
      onClick={onClick}
    >
      <div
        className={classNames(outerClassName, styles.outer, { [styles.none]: !url })}
        style={{ backgroundImage: `url(${url})` }}
      />
      {hasInner && (
        <div className={classNames(innerClassName, styles.inner)}>
          {url ? (
            <video src={url} width='auto' height={height} />
          ) : (
            <div className={styles.empty}>暂无视频</div>
          )}
        </div>
      )}
      {children}
    </div>
  );
};

export default Video;
